import { ScatterPlot } from "@/components/custom/ScatterPlot";
import Navigation from "@/components/navigation";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";

const HomePage = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <div className="flex items-stretch min-h-screen w-full justify-center">
      <h3
        className="absolute top-8 text-[24px] font-rakas cursor-pointer z-40"
        onClick={() => navigate("/")}
      >
        MatterYouMust
      </h3>
      <div className="visualization relative m-8 w-full">
        <div className="visualization-graph m-12 flex fle-1 flex-col absolute top-0 right-0 left-0 bottom-0 z-0">
          <ScatterPlot ignoreColors />
        </div>
        <div className="absolute bottom-24 -left-20 -rotate-90">Poor workload management</div>
        <div className="absolute bottom-0 left-12">Unproductive Dissatisfied</div>
        <div className="absolute top-24 -right-20 -rotate-90">Great workload management</div>
        <div className="absolute top-0 right-12">Productive Satisfied</div>
        <div className="absolute bottom-0 right-32 left-32 flex gap-8 items-center justify-center">
          <div className="flex items-center gap-2 text-[14px]">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="12" height="12" rx="6" fill="#FB923C" />
            </svg>
            Person
          </div>
        </div>
        <div className="visualization-cta absolute left-0 right-0 bottom-0 top-0 flex flex-col gap-12 z-10 content-center justify-center font-normal">
          <h1 className="text-[110px] leading-[110px] text-center font-rakas w-[580px] self-center pointer-events-none">
            Your Future, Your Way.
          </h1>
          <div className="mx-auto">
            <Button variant="secondary" onClick={() => navigate("/form-start")}>
              Get started
            </Button>
          </div>
        </div>
      </div>
      <Navigation />
    </div>
  );
};

export default HomePage;
